import { Link } from 'react-router-dom';
import { usePageMetadata } from '../hooks/usePageMetadata';

export function Terms() {
  usePageMetadata({
    title: 'Terms of Service — PhotoFeeler AI',
    description: 'Terms of service for PhotoFeeler AI photo analysis platform.',
    canonicalPath: '/terms',
  });

  return (
    <div className="pt-24 pb-20 max-w-2xl mx-auto px-5 sm:px-8 animate-fade-in">
      <Link to="/" className="text-xs font-sans text-ink-faint hover:text-rose transition-colors mb-6 inline-block">&larr; Home</Link>
      <h1 className="font-sans text-4xl text-ink mb-8" style={{ fontWeight: 600 }}>Terms of Service</h1>
      <div className="prose-custom">
        <p><strong>Last updated:</strong> March 15, 2026</p>

        <h2>What PhotoFeeler AI is</h2>
        <p>PhotoFeeler AI is a photo analysis tool that uses artificial intelligence to evaluate photos for dating, business, and social media contexts. It provides scores, trait breakdowns, and improvement suggestions.</p>

        <h2>Accounts</h2>
        <p>You must provide a valid email address to create an account. You are responsible for maintaining the security of your account credentials. One account per person.</p>

        <h2>Credits</h2>
        <p>Credits are used to analyze photos. New accounts receive 3 free credits. Additional credits can be purchased. Credits do not expire. Credits are non-refundable except when an analysis fails (in which case the credit is automatically returned).</p>

        <h2>Acceptable use</h2>
        <ul>
          <li>You may only upload photos that you have the right to use</li>
          <li>Do not upload photos of other people without their consent</li>
          <li>Do not upload explicit, illegal, or harmful content</li>
          <li>Do not attempt to reverse-engineer or abuse the AI models</li>
        </ul>

        <h2>AI-generated content</h2>
        <p>Scores and suggestions are generated by AI models and should be treated as opinions, not facts. PhotoFeeler AI is not responsible for decisions made based on AI-generated scores or recommendations.</p>

        <h2>Limitation of liability</h2>
        <p>PhotoFeeler AI is provided &quot;as is&quot; without warranties. We are not liable for any damages arising from use of the service, including but not limited to emotional distress from scores received.</p>

        <h2>Changes</h2>
        <p>We may update these terms. Continued use after changes constitutes acceptance.</p>

        <h2>Contact</h2>
        <p>Questions? Email <a href="mailto:hello@photofeeler.ai" className="text-rose hover:underline">hello@photofeeler.ai</a>.</p>
      </div>
    </div>
  );
}
